// Modules
import React from "react";

const SunshadeIcon = (props) => {
	return (
		<svg
			height="1em"
			viewBox="0 0 512 512"
			width="1em"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path d="M419.678,186.838c-10.788-46.281-37.294-88.264-74.675-118.262c-36.516-29.302-82.124-45.968-129.03-47.281v-5.59
	c0-3.314-2.686-6-6-6c-3.313,0-6,2.686-6,6v5.591c-46.904,1.314-92.512,17.979-129.028,47.281
	C37.431,98.68,10.869,140.854,0.154,187.33c-0.411,1.782,0.014,3.653,1.151,5.084c1.139,1.431,2.867,2.264,4.695,2.264h4.256
	c2.273,0,4.351-1.285,5.367-3.318c5.926-11.859,17.87-19.226,31.172-19.226c13.301,0,25.245,7.367,31.173,19.227
	c1.017,2.033,3.095,3.317,5.367,3.317h8.509c2.272,0,4.351-1.284,5.367-3.317c5.928-11.859,17.872-19.227,31.172-19.227
	c13.301,0,25.246,7.367,31.175,19.227c1.017,2.033,3.095,3.317,5.367,3.317h8.508c2.273,0,4.351-1.284,5.367-3.317
	c5.02-10.041,14.357-16.842,25.173-18.698v225.598h-51.33c-3.314,0-6,2.686-6,6s2.686,6,6,6h114.66c3.314,0,6-2.686,6-6
	s-2.686-6-6-6h-51.33V287.953h6.762c3.313,0,6-2.687,6-6v-7.818c0-3.313-2.687-6-6-6c-3.314,0-6,2.687-6,6v1.818h-0.762v-103.29
	c10.816,1.856,20.153,8.657,25.173,18.698c1.017,2.033,3.095,3.317,5.367,3.317h8.51c2.273,0,4.351-1.285,5.367-3.318
	c5.927-11.859,17.872-19.226,31.173-19.226c13.3,0,25.244,7.367,31.172,19.227c1.017,2.033,3.095,3.317,5.367,3.317h8.509
	c2.273,0,4.351-1.284,5.367-3.317c5.929-11.86,17.873-19.227,31.173-19.227c13.301,0,25.246,7.367,31.174,19.227
	c1.017,2.033,3.095,3.317,5.367,3.317h4.254c0.006,0,0.015-0.001,0.02,0c3.314,0,6-2.686,6-6
	C419.965,188.036,419.864,187.418,419.678,186.838z M46.795,160.134c-10.936,0-21.19,3.708-29.33,10.239
	c12.339-36.021,34.942-68.326,64.99-92.438c26.104-20.948,57.135-35.054,89.894-41.213c-20.81,10.833-39.365,25.988-54.123,44.497
	c-21.837,27.389-34.29,59.94-36.332,94.688C73.149,165.983,60.514,160.134,46.795,160.134z M128.383,160.134
	c-13.361,0-25.7,5.545-34.413,15.003c2.161-31.71,13.675-61.399,33.639-86.438c18.534-23.245,43.509-40.796,71.39-50.417
	c-21.779,42.454-33.979,89.504-35.624,137.496C154.632,165.93,142.043,160.134,128.383,160.134z M209.973,160.134
	c-13.439,0-25.848,5.605-34.57,15.165c1.713-46.136,13.546-91.34,34.57-132.112c21.024,40.772,32.858,85.977,34.57,132.112
	C235.821,165.739,223.412,160.134,209.973,160.134z M291.563,160.134c-13.661,0-26.25,5.797-34.99,15.645
	c-1.646-47.992-13.846-95.042-35.625-137.497c27.881,9.621,52.857,27.173,71.391,50.417c19.965,25.039,31.48,54.729,33.641,86.44
	C317.265,165.68,304.925,160.134,291.563,160.134z M373.151,160.134c-13.717,0-26.352,5.848-35.097,15.771
	c-2.042-34.747-14.495-67.298-36.333-94.687c-14.759-18.509-33.315-33.664-54.125-44.496c32.76,6.158,63.791,20.265,89.897,41.213
	c30.047,24.112,52.65,56.417,64.988,92.439C394.341,163.842,384.086,160.134,373.151,160.134z"/>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
		</svg>
	);
};

export default SunshadeIcon;
